import { Component, OnInit } from "@angular/core";
import { CigarselectorService } from "../services/cigarselector.service";
import { MenuController } from "@ionic/angular";
import { RangeValue } from "@ionic/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Drink } from "../models/drink";
import { Aroma } from "../models/aroma";
import { HumidorService } from "../services/humidor.service";
import { ConfigService } from "../services/config.service";
import { Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-cigarselector",
  templateUrl: "./cigarselector.component.html",
  styleUrls: ["./cigarselector.component.scss"],
})
export class CigarselectorComponent implements OnInit {
  selectorForm: FormGroup;
  //duration und price müssen als RangeValue initialisiert werden
  private duration: RangeValue = { lower: 0, upper: 120 };
  private price: RangeValue = { lower: 0, upper: 1000 };
  private drinkSub: Subscription = null;
  private aromaSub: Subscription = null;
  private configSub: Subscription = null;
  public drinks: Drink[] = [];
  public aromas: Aroma[] = [];
  public currency: string;
  public language = "zh-Hans";
  constructor(
    private cs: CigarselectorService,
    private mc: MenuController,
    private fb: FormBuilder,
    private hs: HumidorService,
    private cfs: ConfigService,
  ) {}
  /**
   * Alle Getränke und Aromen über Service aus DB holen
   * Form initialisieren
   */
  ngOnInit() {
    this.getDrinks();
    this.getAromas();
    this.currency = this.cfs.getCurrency();
    this.initSelectorForm();
    this.configSub = this.cfs.csUpdatedLang().subscribe((changedLang) => {
      this.configSub.unsubscribe();
      this.ngOnInit();
    });
  }
  //Menü schließen
  async closeCigarSelector() {
    await this.mc.close("selectorMenu");
  }
  /**
   * Zigarrenselektor alle Filter zurücksetzen
   */
  public resetSelector() {
    this.selectorForm.controls.duration.setValue(this.duration, {
      emitEvent: true,
      emitModelToViewChange: true,
      emitViewToModelChange: true,
    });
    this.selectorForm.controls.price.setValue(this.price, {
      emitEvent: true,
      emitModelToViewChange: true,
      emitViewToModelChange: true,
    });
    this.selectorForm.controls.strength.setValue(0, {
      emitEvent: true,
      emitModelToViewChange: true,
      emitViewToModelChange: true,
    });
    this.selectorForm.controls.ripingtime.setValue(0, {
      emitEvent: true,
      emitModelToViewChange: true,
      emitViewToModelChange: true,
    });
    this.selectorForm.controls.rating.setValue(0, {
      emitEvent: true,
      emitModelToViewChange: true,
      emitViewToModelChange: true,
    });
    this.selectorForm.controls.fitting_drink.setValue("nothing", {
      emitEvent: true,
      emitModelToViewChange: true,
      emitViewToModelChange: true,
    });
    this.selectorForm.controls.aromaselector.setValue([], {
      emitEvent: true,
      emitModelToViewChange: true,
      emitViewToModelChange: true,
    });
    this.cs.setAttribute("strength", 0);
    this.cs.setAttribute("ripingtime", 0);
    this.cs.setAttribute("rating", 0);
    this.cs.setAttribute("fitting_drink", "nothing");
    this.cs.setAttribute("aromas", []);
    let valueFakeDuration = { min: 0, max: 120 };
    let valueFakePrice = { min: 0, max: 1000 };
    this.cs.setAttribute("duration", valueFakeDuration);
    this.cs.setAttribute("price", valueFakePrice);
    this.getAromas();
    this.getDrinks();
  }

  public async getDrinks(): Promise<void> {
    if (this.drinkSub !== null) {
      this.drinkSub.unsubscribe();
    }
    this.drinkSub = this.hs
      .getAllDrinks()
      .subscribe(async (drinks: Drink[]) => {
        this.drinks = drinks;
      });
  }

  public async getAromas(): Promise<void> {
    if (this.aromaSub !== null) {
      this.aromaSub.unsubscribe();
    }
    this.aromaSub = this.hs
      .getAllAromas()
      .subscribe(async (aromas: Aroma[]) => {
        this.aromas = aromas;
      });
  }

  private async initSelectorForm() {
    this.selectorForm = this.fb.group({
      duration: this.duration,
      price: this.price,
      strength: 0,
      ripingtime: 0,
      rating: 0,
      fitting_drink: "nothing",
      aromaselector: [],
    });
  }

  public async setAttribute(attrName: string, value: any) {
    await this.cs.setAttribute(attrName, value);
  }
}
